<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>账号管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">成员列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="账号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入账号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <TableScrollSlider :table-ref="$refs.scrollTable" />
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="account" label="账号" align="center">
          </el-table-column>
          <el-table-column prop="name" label="姓名" align="center">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column label="是否客服" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.isCustomerService == 0 ? "否" : "是" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.status == 0 ? "正常" : "冻结" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客服昵称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.hxNickName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="部门" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.divisionName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="角色" align="center">
            <template slot-scope="scope">
              <span
                v-for="(item, index) in ruleList"
                :key="index"
                v-if="scope.row.roles == item.id"
                >{{ item.name }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="loginTime"
            label="最近登录"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 1">停用</span>
              <span class="greenColor" v-if="scope.row.status == 0">启用</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="100"
          >
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn redColor1" @click="Delete(scope.row)">
                  删除
                </div>
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.systemData(),
      ruleForm: {
        name: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      ruleList: [],
    };
  },
  mounted() {
    this.getRuleList();
    this.getList();
  },
  methods: {
    resetForm() {
      this.ruleForm.name = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    add() {
      this.$router.push("/accountAdd");
    },
    handleEdit(val) {
      this.$router.push({
        path: "/accountAdd",
        query: {
          id: val.id,
        },
      });
    },
    getRuleList() {
      let param = {
        page: 1,
        pageSize: 1000,
      };
      this.$axios
        .post(`/admapi/sys/roles/list`, param)
        .then(({ data }) => {
          this.ruleList = data.items;
        })
        .catch()
        .finally();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [
          { name: "account", type: "input", value: this.ruleForm.name },
        ],
      };
      this.$axios
        .post(`/admapi/sys/users/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    Delete(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/sys/users/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
